// extracted by mini-css-extract-plugin
export default {"dialogstyle":"styles_dialogstyle__-u3DC","alert-container":"styles_alert-container__lOjJy"};